<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
  <div>
    <div class="footer-form">
      <div class="main-content">
        <h1>在这里快速提交您的培训认证需求</h1>
        <div class="disc">我们将根据您的岗位背景、学习目标和组织需求，推荐适合的AI培训认证方向。</div>
        <div class="rows-4">
          <form-input :data.sync="form.name" label="姓名"></form-input>
          <form-input :data.sync="form.companyName" label="单位"></form-input>
          <form-input :data.sync="form.phone" label="电话 "></form-input>
          <form-input v-if="isMobile" :data.sync="form.subMessage" label="需求" type="area"></form-input>
          <div @click="submit">
            <read-more class="read-more" width="100%" text="提交信息"></read-more>
          </div>
        </div>
        <form-input v-if="!isMobile" :data.sync="form.subMessage" label="需求" type="area"
          style="width: 74.8%"></form-input>
      </div>
    </div>

    <div class="foot">
      <div class="main-content foot-content">
        <div class="foot-badge">
          <img class="foot-image" src="../assets/training/foot/ai.png" alt="智先生AI培训认证" />
        </div>
        <div class="foot-copy">
          <div class="foot-title">智先生AI培训认证</div>
          <div class="foot-desc">以真实场景为牵引，以交付能力为核心，助力AI人才从学习走向落地。</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormInput from "./common/form-input.vue";
import { addDemand } from "@/api";
export default {
  components: {
    FormInput,
  },
  data() {
    return {
      form: {
        name: undefined,
        companyName: undefined,
        phone: undefined,
        subMessage: undefined,
      },
      isMobile: false,
    };
  },
  mounted() {
    // 判断是否为移动设备
    const isMobile = window.innerWidth < 1300;
    this.isMobile = isMobile;
  },
  methods: {
    submit() {
      if (!this.form.name || !this.form.phone) {
        this.$message({
          message: "请填姓名和电话！",
          type: "warning",
        });
        return;
      }
      addDemand(this.form).then(() => {
        this.$message({
          message: "提交成功",
          type: "success",
        });
        this.form = {
          name: undefined,
          companyName: undefined,
          phone: undefined,
          subMessage: undefined,
        };
      });
    },
  },
};
</script>

<style scoped>
.footer-form {
  background-color: #f6f8fd;
  padding-bottom: 64px;
  padding-top: 64px;
}

h1 {
  color: #1f2329;
  font-size: 40px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 22px;
  text-align: left;
}

.disc {
  text-align: justify;
  color: #50627f;
  font-size: 16px;
  line-height: 170%;
  letter-spacing: -0.16px;
  margin-bottom: 22px;
}

.footer-form .rows-4 {
  margin-bottom: 16px;
}

.footer-form .rows-4 button {
  border-radius: 8px;
  background: #1cb3b8;
  border: none;
  font-size: 16px;
  text-align: center;
  line-height: 44px;
  font-weight: 500;
  color: #fff;
  box-sizing: border-box;
  cursor: pointer;
}

.footer-form .rows-4 button:hover {
  transform: scale(1.01);
}

.foot {
  position: relative;
  overflow: hidden;
  padding: 28px 0;
  background-image: url(../assets/training/foot/bg.png);
  background-size: 100% 100% ;
  display: flex;
}

.foot::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0) 35%);
  pointer-events: none;
}

.foot-content {
  position: relative;
  z-index: 1;
  min-height: 92px;
  display: flex;
  align-items: center;
  gap: 24px;
}

.foot-badge {
  width: 96px;
  height: 96px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.foot-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: drop-shadow(0 8px 18px rgba(56, 111, 198, 0.12));
}

.foot-copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.foot-title {
  color: #1f2329;
  font-family: "PingFang SC";
  font-size: 32px;
  font-weight: 500;
  line-height: normal;
}

.foot-desc {
  color: #50627f;
  font-family: "PingFang SC";
  font-size: 24px;
  font-weight: 400;
  line-height: 170%;
}

@media screen and (max-width: 1300px) {
  .foot {
    padding: 15px 0;
  }

  .foot-content {
    min-height: auto;
    gap: 14px;
  }

  .foot-badge {
    width: 56px;
    height: 56px;
  }

  .foot-copy {
    gap: 4px;
  }

  .foot-title {
    font-size: 20px;
  }

  .foot-desc {
    font-size: 14px;
    line-height: 170%;
  }
}
</style>
